<script lang="ts" setup>
import { memberConfig as rocnovelConfig } from './configs/rocnovel'
import { memberConfig as ocereadConfig } from './configs/oceread'
import { memberConfig as talewaveConfig } from './configs/talewave'
import { memberConfig as ficmoonConfig } from './configs/ficmoon'
import { memberConfig as novelarcConfig } from './configs/novelarc'
import { memberConfig as storyellaConfig } from './configs/storyella'
import { memberConfig as silktaleConfig } from './configs/silktale'
import { memberConfig as pearlaConfig } from './configs/pearla'
import { memberConfig as fictoraConfig } from './configs/fictora'
import { memberConfig as marinovelConfig } from './configs/marinovel'
import MemberPageDefault from './components/MemberPage.default.vue'
import MemberPageFicmoon from './components/MemberPage.ficmoon.vue'
import MemberPageNovelarc from './components/MemberPage.novelarc.vue'
import MemberPageTalewave from './components/MemberPage.talewave.vue'
import { loadBrandComponent, loadBrandConfig } from '@/utils/loadBrandConfig'

// 🔥 加载当前品牌配置（构建时 tree-shaking）
const config = loadBrandConfig({
  rocnovel: rocnovelConfig,
  oceread: ocereadConfig,
  talewave: talewaveConfig,
  ficmoon: ficmoonConfig,
  novelarc: novelarcConfig,
  storyella: storyellaConfig,
  silktale: silktaleConfig,
  pearla: pearlaConfig,
  fictora: fictoraConfig,
  marinovel: marinovelConfig,
})

// 🔥 加载当前品牌组件（rocnovel 和 oceread 共用 default，ficmoon 和 novelarc 用专属组件）
const MemberPage = loadBrandComponent({
  rocnovel: MemberPageDefault,
  oceread: MemberPageDefault,
  ficmoon: MemberPageFicmoon,
  novelarc: MemberPageNovelarc,
  storyella: MemberPageNovelarc,
  silktale: MemberPageNovelarc,
  pearla: MemberPageNovelarc,
  fictora: MemberPageFicmoon,
  marinovel: MemberPageDefault,
  talewave: MemberPageTalewave,
})
</script>

<template>
  <div>
    <!-- 🔥 品牌专属页面组件 -->
    <MemberPage :config="config" />
  </div>
</template>
